/**
 * Brazilian Portuguese (pt-BR) mappings for HomePage and Homepage Panel Components
 */

export const homepagePtBR = {
  // BettingPlatformsCard
  "Ask About Your Favorite Fantasy or Sports Bets": "Pergunte Sobre Suas Apostas Esportivas ou Fantasy Favoritas",
  "Get insights on your bets across these platforms": "Obtenha insights sobre suas apostas nessas plataformas",
  "Live betting analysis & insights": "Análise e insights de apostas ao vivo",
  
  // Platform names (keep some as-is for brand recognition)
  "Rei do pitaco": "Rei do pitaco",
  "Superbet": "Superbet", 
  "PixBet": "PixBet",
  "FanDuel": "FanDuel",
  "DraftKings": "DraftKings",
  "Bet365": "Bet365",
  
  // Premium button
  "Unlock Premium Features": "Desbloquear Recursos Premium",
  
  // Footer
  "About Us": "Sobre Nós",
  "FAQ": "Perguntas Frequentes",
  
  // SuggestionChips (from chips.js)
  "Try PickStar's AI analytics suggestions or craft your custom question above!": "Experimente as sugestões de análise de IA do PickStar ou crie sua pergunta personalizada acima!",
  
  // Error messages
  "Error processing message": "Erro ao processar mensagem",
  "Network response was not ok": "Resposta de rede não foi ok",
  
  // PremiumUpsellBanner
  "PREMIUM ACCESS": "ACESSO PREMIUM",
  "Premium Access": "Acesso Premium",
  "Unlock Your AI Assistant's Full Power with StarCoins": "Desbloqueie Todo o Poder do Seu Assistente de IA com StarCoins",
  "Unlimited messages • Advanced analytics • Priority support": "Mensagens ilimitadas • Análises avançadas • Suporte prioritário",
  "Unlimited messages • Advanced analytics • Priority support • Custom sports insights": "Mensagens ilimitadas • Análises avançadas • Suporte prioritário • Insights esportivos personalizados",
  "Upgrade Now": "Fazer Upgrade Agora",
  
  // Homepage Command Center Headers
  "Command Center": "Central de Comando",
  "Quick Actions": "Ações Rápidas",
  "Recent Activity": "Atividade Recente",
  "Trending Games": "Jogos em Destaque",
  "Connected": "Conectado",
  "PRO": "PRO",
  "BASIC": "BÁSICO",
  
  // Premier League Banner
  "Premier League!": "Premier League!",
  "Premier League is Back!": "A Premier League Voltou!",
  "Expert match predictions": "Previsões de jogos",
  "Get expert predictions for all matches": "Receba previsões especializadas para todos os jogos",
  "View Matches": "Ver Jogos",
  
  // QuickActionsGrid
  "New Chat": "Novo Chat",
  "Start New Chat": "Iniciar Novo Chat",
  "Ask your AI assistant": "Pergunte ao seu assistente de IA",
  "QuickPicks": "Palpites Rápidos",
  "Fast AI predictions": "Previsões rápidas de IA",
  "Buy Coins": "Comprar Moedas",
  "Get StarCoins for premium": "Obtenha StarCoins para premium",
  "AI Exchange": "Câmbio de IA",
  "Market insights & trends": "Insights e tendências do mercado",
  "Sports Hub": "Central de Esportes",
  "Live stats & predictions": "Estatísticas e previsões ao vivo",
  "Market View": "Visão do Mercado",
  "Browse active games": "Explorar jogos ativos",
  
  // HistorySection
  "Recent Conversations": "Conversas Recentes",
  "No conversations yet": "Nenhuma conversa ainda",
  "Start your first chat": "Iniciar primeiro chat",
  "Start your first chat →": "Inicie seu primeiro chat →",
  "View all conversations": "Ver todas as conversas",
  "View all conversations →": "Ver todas as conversas →",
  "New conversation": "Nova conversa",
  "Just now": "Agora mesmo",
  "Continue": "Continuar",
  "Sign in to view your conversation history": "Entre para ver seu histórico de conversas",
  "Sign in": "Entrar",
  
  // BottomNavBar
  "Home": "Início",
  "Chat": "Perguntar IA",
  "Sports": "Esportes",
  "Profile": "Perfil",
  "History": "Histórico",
  "Account": "Conta",
  
  // Time formatting
  "m ago": "m atrás",
  "h ago": "h atrás",
  "d ago": "d atrás",
  
  // Economy Strip
  "StarCoins": "StarCoins",
  "Spins Left": "Rodadas Restantes",
  "Day": "Dia",
  "Streak": "Sequência",
  "in": "em",
  "days": "dias",
  
  // Featured Games
  "Featured Games": "Jogos em Destaque",
  "Want all games?": "Quer todos os jogos?",
  "Here": "Aqui",
  "Today's Top Matches": "Destaques de Hoje",
  "See All Games": "Ver Todos os Jogos",
  "View All Games": "Ver Todos os Jogos",
  "Games & Picks": "Jogos e Palpites",
  "View Game": "Ver Jogo",
  "Match Finished": "Jogo Finalizado",
  "Home": "Casa",
  "Draw": "Empate",
  "Away": "Visitante",
  
  // StarCoinPromoCard
  "Limited Offer": "Oferta Limitada",
  "SIGN UP": "CADASTRE-SE",
  "TODAY": "HOJE",

  // Navigation
  "Tour": "Tour",
  "&": "&",
  "GET": "GANHE",
  "200": "200",
  "STARCOIN": "STARCOIN",
  "BONUS": "BÔNUS",
  "*On 1K StarCoin packages and above": "*Em pacotes de 1K StarCoins ou mais",
  "Claim Now": "Resgatar Agora",

  // Daily Allowances Banner
  "Free Daily Access": "Acesso Diário Grátis",
  "AI Chats": "Chats IA",
  "X-Pick": "X-Pick",
  "In-Depth Game Prediction": "Previsão de Jogo Aprofundada",

  // AIExchangePromoCard
  "AI Market Live": "Mercado IA Ao Vivo",
  "AI EXCHANGE": "CÂMBIO DE IA",
  "Track AI consensus & market trends": "Rastreie consenso de IA e tendências de mercado",
  "LIVE": "AO VIVO",
  "1. Buy Coins": "1. Comprar Moedas",
  "2. Use Quick Picks": "2. Usar Palpites Rápidos",
  "3. Compete!": "3. Competir!",
  "4. Vote on games": "4. Vote nos jogos",
  "See what 50K+ bettors are tracking": "Veja o que 50K+ apostadores estão rastreando",
  "Explore Now": "Explorar Agora",

  // Game Card Long Press Actions
  "Send to AI Chat": "Enviar para Chat IA",
  "Ask PickAI for predictions and insights about this match": "Pergunte ao PickAI por previsões e insights sobre esta partida",
  "Send to Chat": "Enviar para Chat",
  "Sent to Chat": "Enviado para Chat",
  "Sent to Chat!": "Enviado para Chat!",
  "AI Analysis Options": "Opções de Análise IA",
  "Full Analysis": "Análise Completa",
  "Quick Take": "Análise Rápida",
  "Compare": "Comparar Times",
  "Best Bets": "Melhores Apostas",

  // Game status
  "LIVE": "AO VIVO",
  "FT": "FIM",
  "HT": "INT",
  "Not started": "Não iniciado",
  "Live": "Ao Vivo",
  "Final": "Final",
  "Upcoming": "Próximo",

  // Game card prompts for chat
  "Analyze this": "Analise este jogo de",
  "game": "jogo",
  "League": "Liga",
  "Status": "Status",
  "Score": "Placar",
  "Time": "Horário",
  "What are your predictions and betting insights for this match?": "Quais são suas previsões e insights de apostas para esta partida?",
  "Quick analysis for": "Análise rápida para",
  "Compare teams": "Compare os times",
  "in": "em",
  "Best bets for": "Melhores apostas para",
  "Current": "Atual",
  "vs": "vs",

  // Enhanced Game Card - Prediction Feature
  "Predict": "Previsão",
  "Predicting...": "Prevendo...",
  "Chat": "Chat",
  "Sent": "Enviado",
  "Add to chat": "Adicionar ao chat",
  "7 coins?": "7 moedas?",
  "Spend 7 coins for AI prediction?": "Gastar 7 moedas para previsão IA?",
  "Use free xPicks?": "Usar xPicks grátis?",
  "Spend 9 coins for xPicks?": "Gastar 9 moedas para xPicks?",
  "Your prediction will be saved in chat history!": "Sua previsão será salva no histórico do chat!",
  "Cancel": "Cancelar",
  "Confirm": "Confirmar",
  "AI Pick": "Escolha IA",
  "Analyze in Chat": "Analisar no Chat",

  // Prediction Confirmation Modal (if used later)
  "AI Quick Prediction": "Previsão Rápida IA",
  "Cost": "Custo",
  "Star Coins": "Moedas Estrela",
  "Your balance": "Seu saldo",
  "coins": "moedas",
  "You need": "Você precisa de",
  "more coins for this prediction": "mais moedas para esta previsão",
  "What you get": "O que você recebe",
  "AI-powered winner prediction": "Previsão de vencedor com IA",
  "Confidence level (HIGH/MED/LOW)": "Nível de confiança (ALTO/MÉDIO/BAIXO)",
  "Brief reasoning for the prediction": "Breve raciocínio para a previsão",
  "1-hour cached result (no re-charge)": "Resultado em cache por 1 hora (sem nova cobrança)",
  "Star Coins are refunded if prediction fails": "Moedas Estrela são reembolsadas se a previsão falhar",
  "Get Prediction": "Obter Previsão",
  "Get more Star Coins": "Obter mais Moedas Estrela",

  // NuclearTopRail Navigation Pills
  "QuickPicks": "Palpites Rápidos",
  "Buy Coins": "Comprar Moedas",
  "AI Market": "Mercado IA",

  // SportsFeed EmptyState
  "No trending games right now": "Não há jogos em destaque agora",
  "Please refresh, or try the": "Por favor, atualize ou tente o",
  "sports hub": "central de esportes",
  "for all games": "para todos os jogos",
  "No live football games right now": "Não há jogos de futebol ao vivo agora",
  "No live MLB games right now": "Não há jogos da MLB ao vivo agora",
  "No live NFL games right now": "Não há jogos da NFL ao vivo agora",
  "No matches found for this league": "Nenhuma partida encontrada para esta liga",
  "Check back during game time": "Volte durante o horário do jogo",
  "Try selecting a different league or check \"All Leagues\"": "Tente selecionar uma liga diferente ou marque \"Todas as Ligas\"",
  "Week 1 starts September 4, 2025": "Semana 1 começa em 4 de setembro de 2025",
  "Retry": "Tentar novamente",
  "Clear Filters": "Limpar Filtros",

  // NuclearTopRail - Tab Labels
  "Trending": "Tendências",
  "Live": "Ao Vivo",
  "Upcoming": "Próximos",
  "Next": "Próximos",
  "All": "Todos",
  "Start Researching in Chat": "Começar Pesquisa no Chat",

  // Auth Modal
  "Sign in to continue": "Entre para continuar",
  "Create a free account to access this feature": "Crie uma conta gratuita para acessar este recurso",
  "Start chatting with AI": "Comece a conversar com IA",
  "Sign in to get personalized sports insights and predictions": "Entre para obter insights e previsões esportivas personalizadas",
  "View your history": "Ver seu histórico",
  "Sign in to access your conversation history and saved predictions": "Entre para acessar seu histórico de conversas e previsões salvas",
  "Access live sports data": "Acessar dados esportivos ao vivo",
  "Sign in to get real-time sports updates and analytics": "Entre para obter atualizações e análises esportivas em tempo real",
  "Get AI predictions": "Obter previsões de IA",
  "Sign in to receive AI-powered game predictions and analysis": "Entre para receber previsões e análises de jogos com IA",
  "Manage Star Coins": "Gerenciar Moedas Estrela",
  "Sign in to view and use your Star Coins balance": "Entre para ver e usar seu saldo de Moedas Estrela",
  "Join thousands of users getting AI-powered sports insights": "Junte-se a milhares de usuários obtendo insights esportivos com IA",
  "Continue with Google": "Continuar com Google",
  "or": "ou",
  "Already have an account? Sign in": "Já tem uma conta? Entre",
  "Free to start": "Grátis para começar",
  "No credit card": "Sem cartão de crédito",
  "Cancel anytime": "Cancele a qualquer momento"
};